<template>
  <section class="lg:container lg:mx-auto px-5">
    <Fieldset :legend="toUpperCase(translate('presentation', 'ucfirst'))"
      class="relative w-full px-5 pb-5 mt-10 md:mt-7 bg-white rounded-lg shadow-md border border-color-iron">
     <Skeleton v-if="isLoading && presentation" height="1.5rem"></Skeleton>     
      <span class="" v-else-if="!isLoading && JSON.stringify(presentation) != '{}'">
        <p class="mt-4 relative">
        <!-- Motion loader box -->
        <span :class="isLoadingPre || isTranslating ? 'block':'hidden'"
          class="w-full h-full absolute top-0 flex justify-center items-center" style="background-color: rgba(0,4,0, 0.2);">
          <MotionLoaderComponent class="w-28"  />
        </span>
          <span class="presentation-text" :class="{ 'uppercase': true }">
            {{ translatedPresentation || presentation.presentation_text }}
          </span>
        </p>
        <i @click="isLoadingPre ? '' : showModal('update','presentation',presentation)" class="pi pi-pencil cursor-pointer absolute -top-2 right-5 text-lg"></i>
      </span>
      <span v-else>
        <p>
          {{ translate('no presentation', 'ucfirst') }}
        </p>
        <i @click="isLoadingPre ? '' : showModal('create','presentation')" class="pi pi-plus cursor-pointer absolute top-1 right-5 text-lg"></i>
      </span>
    </Fieldset>
 
    <ModalDialogComponent :isvisible="visible" @close-modal="closeModalDialog">
      <template #title>
        {{ displayModalTitle }}
      </template>
      <template #content>
        <ProfessionalPresentationForm :presentation-to-update="presentationToUpdate" @presentation-updated="updatePresentation" @close-modal="closeModalDialog" />
      </template>
    </ModalDialogComponent>

  </section>
</template>

<script setup>
import { ref, onMounted, onUpdated, watch } from 'vue'
import Fieldset from "primevue/fieldset";
import Skeleton from 'primevue/skeleton';
import { translate } from "@/composables/translate";
import requestHandler from "@/composables/requestHandler";
import useModalCurriculum from "@/composables/modalDialogCurriculum";
import ModalDialogComponent from "@/components/Utils/ModalDialogComponent.vue";
import ProfessionalPresentationForm from "@/components/Dashboard/Applicant/FormsCurriculum/ProfessionalPresentationForm.vue";
import MotionLoaderComponent from "@/components/Svg/MotionLoaderComponent.vue";
import useAutoTranslate from "@/composables/autoTranslate";
import { toUpperCase } from '@/composables/textUtils';


const props = defineProps({
  presentations: {
    type: Array,
    required: true,
    default: () => []
  }
});

let isLoading = ref(false)
let presentation = ref({})
let presentationToUpdate = ref({})
let visible = ref(false)  
let isLoadingPre = ref(false)
let preUpdated = ref(false)

// Variáveis para tradução automática
let translatedPresentation = ref('')
let isTranslating = ref(false)

let { toggleCreateUpdateTitle, displayModalTitle } = useModalCurriculum()

// Usar o composable de tradução automática
const { translateAndFormat } = useAutoTranslate()


// ############ Criação de Métodos/Funções ############

/**
 * Traduz automaticamente a apresentação para o idioma do usuário
 */
async function translatePresentation() {
  if (!presentation.value.presentation_text) {
    translatedPresentation.value = '';
    return;
  }

  try {
    isTranslating.value = true;
    const translated = await translateAndFormat(presentation.value.presentation_text);
    translatedPresentation.value = translated;
  } catch (error) {
    console.error('Erro ao traduzir apresentação:', error);
    // Em caso de erro, usar o texto original em maiúsculas
    translatedPresentation.value = presentation.value.presentation_text.toUpperCase();
  } finally {
    isTranslating.value = false;
  }
}

function showModal(type, title,pre={}) {

  toggleCreateUpdateTitle(type,title)
  presentationToUpdate.value = pre
  visible.value = true
}
 
function closeModalDialog(event){  
  visible.value = event
}

async function updatePresentation(){  

  isLoadingPre.value = true
  const response = await requestHandler.executeRequest("/api/curriculum",{},"get");
  if (response.success) {
    presentation.value = response.data.presentations[0];
    // Traduzir a apresentação após atualizar
    await translatePresentation();
  }
  
  preUpdated.value = true
  isLoadingPre.value = false
}

onUpdated(() => {
  isLoading.value = false
  if (props.presentations != undefined && JSON.stringify(props.presentations) != '[]' && !preUpdated.value) {
    presentation.value = props.presentations[0]
    // Traduzir quando os dados chegarem
    translatePresentation();
  }
})

// Watcher para traduzir quando a apresentação mudar
watch(() => presentation.value.presentation_text, (newText) => {
  if (newText) {
    translatePresentation();
  }
}, { immediate: true });

onMounted(() => {
  isLoading.value = true
});
</script>

<style scoped>
.presentation-text {
  text-transform: uppercase;
  font-weight: 500;
  line-height: 1.6;
}
</style>